import { EditorDefns } from "../../../utility";
import { ArsTableBody, ArsTableRowHeader, defaultRowHeight } from "../interface";
import { arst_tableGroupDepth } from "./arst_arsToTableGroup";
import { blankRowHeaderCell } from "./blankRowHeaderCell";

/**
 * Check that rowHeader has the correct heights and number of cells
 *
 * @param bodyData - Current ARS table body data to check rowHeaders against
 * @param editorProps - Editor properties for blankT and isT typeguard
 */
export const arst_checkRowHeaders = <T>(
  bodyData: ArsTableBody<T>,
  editorProps: EditorDefns<T>,
): ArsTableRowHeader<T>[] => {
  const columnDepth = Math.max(
    ...bodyData.columns.map((group) => arst_tableGroupDepth(group, editorProps)),
    1,
  );
  const rowDepth = Math.max(
    ...bodyData.rows.map((group) => arst_tableGroupDepth(group, editorProps)),
    1,
  );
  const rowHeaderTemplate = blankRowHeaderCell(editorProps.blankT, columnDepth);
  // Check that a change is required
  if (
    bodyData.rowHeaders.length === rowDepth &&
    bodyData.rowHeaders.every(
      (rowHeader) =>
        rowHeader.heights.length === columnDepth &&
        rowHeader.heights.every((height) => height === rowHeaderTemplate.heights[0]),
    )
  ) {
    return bodyData.rowHeaders;
  }
  // Otherwise create new rowHeaders with correct heights and number of cells
  const currentRowHeights = bodyData.rowHeaders.length > 0 ? bodyData.rowHeaders[0].heights : [];
  const newRowHeights = [
    ...currentRowHeights.slice(0, columnDepth),
    ...Array.from({ length: columnDepth - currentRowHeights.length }, () => defaultRowHeight),
  ];
  const newRowHeaders = [
    ...bodyData.rowHeaders
      .slice(0, rowDepth)
      .map((rowHeader) => ({ ...rowHeader, heights: newRowHeights })),
    ...Array.from({ length: rowDepth - bodyData.rowHeaders.length }, () => ({
      ...rowHeaderTemplate,
    })),
  ];
  return newRowHeaders;
};
